import React from 'react';

// Components
import ModalV2 from '@/views/components/modals/ModalV2';
import { CreateBody } from './components';

// Types
import HistoricalScenario from '@/types/historical-scenario';

interface CreateModalProps {
  onClose: () => void;
  onSubmit: (scenario: Partial<HistoricalScenario>) => void;
  show: boolean;
  isLoading: boolean;
}

export const CreateModal: React.FC<CreateModalProps> = ({ onClose, onSubmit, show, isLoading }) => {
  const i18nBasePath = 'Comparison.HistoricalScenarios.CreateModal';
  return (
    <ModalV2
      body={<CreateBody i18nBasePath={i18nBasePath} onClose={onClose} onSubmit={onSubmit} isLoading={isLoading} />}
      onClose={onClose}
      show={show}
      title={`${i18nBasePath}.Title`}
    />
  );
};
